import React from 'react';
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";

function MyTicketCard(){

    const {MyTicket, updateMyTicket} = useContext(MyContext);


    const view = async () => {
        updateMyTicket("Ticket")
    }

    const closed = async () => {
        updateMyTicket("AllClosed")
    }

    return (
       
        <>
          <div style={{display:'flex'}}>
<div class="col-md-5">
            <div class="card p-3 mb-4" style={{marginBottom:"20px"}}>
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard">   <span class="material-symbols-rounded">confirmation_number</span> </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Ticket</h6> <span>Active Ticket</span>
                        </div>
                    </div>
                    <div class="badge Process"> <span>Site Visit</span> </div>
                </div>
                <div class="mt-3">
                    <p class="heading"><strong>Client Name</strong></p>
                    <div class="mt-3">
                        
                        <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">mail</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>adf@adf.com</span>
  
  

  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px", }}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Phone: </strong>045 827 2541</span>


  </div>
  
  <hr />


            <div className="d-flex flex-row align-items-center" style={{marginBottom:"20px"}}>
                <div class="iconCard">   <span class="material-symbols-rounded">chat</span> 
                </div>
                <div class="ms-2 c-details">
                            <h6 class="mb-0">Admin</h6> 
                            <span>4 Messages</span>
                </div>
            </div>

            <div className='message'>
            <span className="smallInfo "><strong className=' Process'><span>Admin</span></strong>
            Gridvolt will provide a site attendance date for remote firmware update.

-I will follow up to find out when are they planning to visit the site
            </span>
            </div>
            

  <div className='smallInfo' style={{display: "flex", marginTop:"20px"}}>
  
    <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Number</strong> 5238923844</span>
  
  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px"}}><strong>Ticket Logged: </strong>14 June 2013</span>

  
  </div>

  

                     {/*    <div class="mt-3"> <span class="text1">32 Applied <span class="text2">of 50 capacity</span></span> </div>*/}
                    </div>


                    <hr />
                    <div className='smallInfo' style={{display: "flex", justifyContent:"end"}}>
 
  <span style={{width:"31%"}}>

<span className="BIcon3" onClick={view} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"4px"}} >confirmation_number</span> <span style={{paddingTop:"8px", paddingLeft:"5px"}}>View Ticket</span></span>

</span></div>
                </div>
            </div>




{/* Closed Ticket */}
<div class="card p-3 mb-2">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        <span class="material-symbols-rounded">confirmation_number</span>
                         </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Closed</h6> <span>Closed Ticket</span>
                        </div>
                    </div>
                   {/* <div class="badge"> <span>Pending</span> </div> */}
                </div>
                <div class="mt-3">

                    <span style={{display:"flex", justifyContent:"space-between"}}>
                        <p class="heading" style={{paddingTop:"15px"}}><strong>Client Name</strong></p>
                        
                        

                        <span style={{width:"31%", paddingRight:"20px"}}>

{/* <span className="BIcon3" onClick={""} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"7px"}} >confirmation_number</span> <span style={{paddingTop:"12px", paddingLeft:"5px"}}>View Ticket</span></span>*/}

</span>

                    </span>
                    <div className='smallInfo' style={{display: "flex", marginTop:"0px"}}>
  
  <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Number</strong> 5238923844</span>




<span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Closed: </strong>16 June 2013</span>

<span class="material-symbols-rounded writing" style={{paddingLeft:"20px", color:"#e1642d"}}>confirmation_number</span> 
<span className='link' onClick={view}>
  {/**/} <span style={{marginTop: "-3px", paddingLeft:"2px"}}><strong>View </strong>Ticket</span></span>
</div>

                 

               

                    <hr />

                    <span style={{display:"flex", justifyContent:"space-between"}}>
                        <p class="heading" style={{paddingTop:"15px"}}><strong>Client Name</strong></p>
                        
                        

                        <span style={{width:"31%", paddingRight:"20px"}}>

{/* <span className="BIcon3" onClick={""} style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"7px"}} >confirmation_number</span> <span style={{paddingTop:"12px", paddingLeft:"5px"}}>View Ticket</span></span>*/}

</span>

                    </span>
                    <div className='smallInfo' style={{display: "flex", marginTop:"0px"}}>
  
  <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Number</strong> 5238923844</span>




<span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Closed: </strong>16 June 2013</span>

<span class="material-symbols-rounded writing" style={{paddingLeft:"20px", color:"#e1642d"}}>confirmation_number</span> 
<span className='link' onClick={view}>
  {/**/} <span style={{marginTop: "-3px", paddingLeft:"2px"}}><strong>View </strong>Ticket</span></span>
</div>


                    <hr />




                    <div class="mt-3">
                       
                    <div className='smallInfo' style={{display: "flex"}}>{/* <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>Randburg</span>*/}
  
  <span class="material-symbols-rounded writing" style={{color:"#e1642d"}}>confirmation_number</span> 
  <span className='link' onClick={closed}>
  <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>View all Closed </strong>Tickets</span></span>
  </div>

                    </div>
                </div>
            </div>
{/* Closed Ticket End */}




            
            </div>



            <div class="col-md-5">
            <div class="card p-3 mb-2">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard"> 
                        <span class="material-symbols-rounded">Approval</span>
                         </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Approval</h6> <span>Ticket Approval</span>
                        </div>
                    </div>
                   {/*  <div class="badge"> <span>Pending</span> </div>*/}
                </div>
                <div class="mt-3">

                <div>
                      <span style={{display:"flex", justifyContent:"space-between"}}>
                        <p class="heading" style={{paddingTop:"15px"}}><strong>Client Name</strong></p>


                        <div class="badge" style={{paddingTop:"15px"}}> <span>Pending</span> </div>
                  

                    </span>
                </div>


                <div className='message' style={{marginTop:"15px"}}>
            <span className="smallInfo "><strong className=' Process'><span>Admin</span></strong>
            Please submit the Pictures of the work done to process your Submition
            </span>
            </div>




            <div className='smallInfo' style={{display: "flex", marginTop:"20px"}}>
  
  <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Number</strong> 5238923844</span>




<span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Approval: </strong>16 June 2013</span>

<span class="material-symbols-rounded writing" style={{paddingLeft:"20px", color:"#e1642d"}}>confirmation_number</span> 
<span className='link' onClick={""}>
  {/**/} <span style={{marginTop: "-3px", paddingLeft:"2px"}}><strong>View </strong>Ticket</span></span>
</div>

                    <hr />

                    <span style={{display:"flex", justifyContent:"space-between"}}>
                        <p class="heading" style={{paddingTop:"15px"}}><strong>Client Name</strong></p>

                        <div class="badge" style={{paddingTop:"15px"}}> <span>Pending</span> </div>
                        


                    </span>

                    <div className='smallInfo' style={{display: "flex", marginTop:"20px"}}>
  
  <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Number</strong> 5238923844</span>




<span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Approval: </strong>16 June 2013</span>

<span class="material-symbols-rounded writing" style={{paddingLeft:"20px", color:"#e1642d"}}>confirmation_number</span> 
<span className='link' onClick={""}>
  {/**/} <span style={{marginTop: "-3px", paddingLeft:"2px"}}><strong>View </strong>Ticket</span></span>
</div>

                    <hr />

                    <span style={{display:"flex", justifyContent:"space-between"}}>
                        <p class="heading" style={{paddingTop:"15px"}}><strong>Client Name</strong></p>

                        <div class="badge Approved" style={{paddingTop:"15px"}}> <span>Approved</span> </div>
                        

                    
                    </span>

                    <div className='smallInfo' style={{display: "flex", marginTop:"20px"}}>
  
  <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Number</strong> 5238923844</span>




<span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Approval: </strong>16 June 2013</span>

<span class="material-symbols-rounded writing" style={{paddingLeft:"20px", color:"#e1642d"}}>confirmation_number</span> 
<span className='link' onClick={""}>
  {/**/} <span style={{marginTop: "-3px", paddingLeft:"2px"}}><strong>View </strong>Ticket</span></span>
</div>

                    <hr />



                    <div class="mt-3">
                       
                    <div className='smallInfo' style={{display: "flex"}}>{/* <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>Randburg</span>*/}
  
 
  <span class="material-symbols-rounded writing" style={{color:"#e1642d"}}>confirmation_number</span> {/* */}
  
  <span className='link' onClick={view}> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>View all Approved and Pending </strong>Ticket</span></span>
  </div>

                    </div>
                </div>
            </div>
            </div>






            </div>
        </>
    )
}

export default MyTicketCard;






















